import React, { Suspense } from "react";
import { Routes, Route } from "react-router-dom";
import Layout from "./Layout";
import { ContentStatusProvider } from "./content-status";
import ScrollToTop from "./ScrollToTop";
import ErrorBoundary from "../components/ErrorBoundary";

import Home from "../features/Home";

// Lazy load secondary pages
const About = React.lazy(() => import("../features/About"));
const Visit = React.lazy(() => import("../features/Visit"));
const Giving = React.lazy(() => import("../features/Giving"));
const Contact = React.lazy(() => import("../features/Contact"));
const Events = React.lazy(() => import("../features/Events"));
const PrivacyPolicy = React.lazy(() => import("../features/PrivacyPolicy"));
const Resources = React.lazy(() => import("../features/resources/Resources"));
const ResourceDetail = React.lazy(() => import("../features/resources/ResourceDetail"));
const Videos = React.lazy(() => import("../features/Videos"));
const Gallery = React.lazy(() => import("../features/Gallery"));
const Benevolence = React.lazy(() => import("../features/Benevolence"));

// Loading fallback
const PageLoader = () => (
    <div className="min-h-screen flex items-center justify-center">
        <div className="w-12 h-12 border-4 border-primary border-t-transparent rounded-full animate-spin"></div>
    </div>
);

function App() {
    return (
        <ErrorBoundary>
            <ContentStatusProvider>
                <ScrollToTop />
                <Routes>
                    <Route path="/" element={<Layout />}>
                        <Route index element={<Home />} />
                        <Route
                            path="about"
                            element={
                                <Suspense fallback={<PageLoader />}>
                                    <About />
                                </Suspense>
                            }
                        />
                        <Route
                            path="visit"
                            element={
                                <Suspense fallback={<PageLoader />}>
                                    <Visit />
                                </Suspense>
                            }
                        />
                        <Route
                            path="giving"
                            element={
                                <Suspense fallback={<PageLoader />}>
                                    <Giving />
                                </Suspense>
                            }
                        />
                        <Route
                            path="contact"
                            element={
                                <Suspense fallback={<PageLoader />}>
                                    <Contact />
                                </Suspense>
                            }
                        />
                        <Route
                            path="events"
                            element={
                                <Suspense fallback={<PageLoader />}>
                                    <Events />
                                </Suspense>
                            }
                        />
                        <Route
                            path="privacy-policy"
                            element={
                                <Suspense fallback={<PageLoader />}>
                                    <PrivacyPolicy />
                                </Suspense>
                            }
                        />
                        <Route
                            path="resources"
                            element={
                                <Suspense fallback={<PageLoader />}>
                                    <Resources />
                                </Suspense>
                            }
                        />
                        <Route
                            path="resources/:slug"
                            element={
                                <Suspense fallback={<PageLoader />}>
                                    <ResourceDetail />
                                </Suspense>
                            }
                        />
                        <Route
                            path="videos"
                            element={
                                <Suspense fallback={<PageLoader />}>
                                    <Videos />
                                </Suspense>
                            }
                        />
                        <Route
                            path="gallery"
                            element={
                                <Suspense fallback={<PageLoader />}>
                                    <Gallery />
                                </Suspense>
                            }
                        />
                        <Route
                            path="benevolence"
                            element={
                                <Suspense fallback={<PageLoader />}>
                                    <Benevolence />
                                </Suspense>
                            }
                        />
                    </Route>
                </Routes>
            </ContentStatusProvider>
        </ErrorBoundary>
    );
}

export default App;
